import React, { useState } from "react";
import { Button, Stack, Typography } from "@mui/material";
import Iconify from "../../../components/Iconify";
import FrmAgregarPlaza from "./forms/FrmAgregarPlaza";
const HeaderPlazas = ({
  setOpenDialog,
  setBodyDialog,
  setOpenSnackBar,
  setErrorGraph,
}) => {
  //Abrir el dialog
  const handleOpenDialog = () => {
    setBodyDialog(
      <FrmAgregarPlaza
        setOpenDialog={setOpenDialog}
        setErrorGraph={setErrorGraph}
        setOpenSnackBar={setOpenSnackBar}
      />
    );
    setOpenDialog(true);
  };

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      mb={5}
    >
      <Typography variant="h4" gutterBottom>
        Catálogo de Plazas
      </Typography>
      <Button
        onClick={() => handleOpenDialog()}
        startIcon={<Iconify icon="eva:plus-fill" />}
      >
        Nuevo registro
      </Button>
    </Stack>
  );
};

export default HeaderPlazas;
